export default __webpack_public_path__ + "static/media/Odisha Biz News.a569dce2.png";